/** One health system as returned by the shared source search. */
export type HealthSystemOption = {
  fhirBaseUrl: string;
  name: string;
  logo: string | null;
  type: string | null;
};

/**
 * What picking a row does. `add` suggests the system to a patient who will sign
 * in later (Workflow 2); `connect` sends the person picking it straight to that
 * system's sign-in (Workflow 1, where the owner is the patient).
 */
export type HealthSystemRowAction = "add" | "connect";

/** One labelled group of rows inside the picker's list. */
export type HealthSystemSection = {
  /** Stable key, also used as the group heading's id. */
  id: string;
  /** Group heading, rendered uppercase. */
  label: string;
  sources: HealthSystemOption[];
};

/** One connected health system that has stopped returning records. */
export type ConnectionNeedingSignIn = {
  id: string;
  name: string;
  fhirBaseUrl: string;
};

/** Row affordance per action — the pending label, and the settled one. */
export const ROW_ACTION_COPY = {
  add: { pending: null, settled: "Added" },
  connect: { pending: "Connect", settled: "Connected" },
} as const;

/** How many characters it takes before the search replaces the groups. */
export const SEARCH_MIN_LENGTH = 2;

/** How many logos the strip shows before it stops and counts the rest. */
export const LOGO_LIMIT = 5;
